module.exports = __webpack_public_path__ + "static/media/locked.acc43305.png";